import { authHeader, handleResponse } from './helper';
import { apiRxUrl } from '../config';

export const getRxViewerUrl = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${apiRxUrl}/edx/getViewerUrl`);

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const createRxOrder = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify({
      admissionPatientExamId: params.admissionPatientExamId,
      rxType: params.rxType,
    })
  };

  const url = new URL(`${apiRxUrl}/edx/sendOrderToEDX`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getEnabledBranch = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
  };

  const url = new URL(`${apiRxUrl}/edx/getEnabledBranch`);
  
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const sendAllOrders = async (admissionPatientId) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify({
      admissionPatientId: admissionPatientId
    })
  };

  const url = new URL(`${apiRxUrl}/edx/sendOrderFromAdmissionPatient`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const linkVigentExam = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify({
      ...params
    })
  };

  const url = new URL(`${apiRxUrl}/edx/linkVigentExam`);
  return await fetch(url, requestOptions).then(handleResponse);
};